import RadioCircle from '@components/RadioButton/RadioCircle';
import Row from '@components/Row';
import Text from '@components/Text';
import styled from '@emotion/styled';
import { ReactNode } from 'react';

export interface LabelValue {
    value: string;
    label?: string;
    trailing?: ReactNode;
}

interface Props {
    data: LabelValue;
    value?: string;
    onChange?: (v: string) => void;
}

function RadioButtonRow({ data, onChange, value }: Props) {
    const { label, trailing } = data;
    const selected = value === data.value;
    return (<Container fullWidth
        data-selected={selected}
        justify='space-between'
        align='center'
        onClick={() => onChange?.(data.value)} >
        <Row spacing={8}>
            <RadioCircle isSelected={selected} />
            <Text>{label ?? data.value}</Text>
        </Row>
        {trailing && (
            <Text>{trailing}</Text>
        )}
    </Container>);
}

const Container = styled(Row)`
    cursor: pointer;
`;

export default RadioButtonRow;
